import React from "react";
import { Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import "./FloatingActionButton.scss";

export const FloatingActionButton = () => {
    return (
        <Button className="btn btn-tertiary rounded-circle position-fixed bottom-0 end-0 m-4 shadow floating-action-button d-flex align-items-center justify-content-center" target="_blank" href="mailto:info@socialvalue.de?subject=Social%20Value%20SpendenKick" title="Jetzt Kontakt aufnehmen!">
            <FontAwesomeIcon icon={faEnvelope} />
        </Button>
    );
};
